<template>
    <div style="display: flex;line-height: 50px;height: 50px">
        <div style="margin-top: 3px;">
            <i :class="icon" style="font-size: 20px;cursor: pointer;" @click="collapse"></i>
        </div>
        <div class="text2">
          <span>
           <svg  version="1.1">
            <text y="70%" x="50%" font-family="aixinziti" text-anchor="middle">梦的开始·粉裙星物语</text>
           </svg>
          </span>
        </div>
        <el-dropdown>
          <i class="el-icon-monitor
" style="margin-right: 0;"><el-button style="border: medium;">{{user.name || ''}}</el-button></i>
            <el-dropdown-menu slot="dropdown" style="margin-top: -5px">
                <el-dropdown-item @click.native="toUser" >身份中心</el-dropdown-item>
                <el-dropdown-item @click.native="logout" >离开秘境</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>

    </div>
</template>

<script>
    export default {
        name: "Header",
        data(){
            return {
                user : JSON.parse(sessionStorage.getItem('CurUser') || '{}')
            }
        },
        props:{
            icon:String
        },
        methods:{
            toUser(){
                console.log('to_user')

                this.$router.push("/PersonalCenter")
            },
            logout(){
                console.log('logout')

                this.$confirm('您确定要离开秘境吗?', '提示', {
                    confirmButtonText: '确定',  //确认按钮的文字显示
                    type: 'warning',
                    center: true, //文字居中显示
                    customClass: 'leave-dialog', // 弹窗圆角美化样式（见下方全局样式）

                })
                    .then(() => {
                        this.$message({
                            type:'success',
                            message:'已离开秘境'
                        })

                        // 仅返回落地页，不清除登录态；账号仍保持登录，可随时再进后台
                        this.$router.push("/")
                    })
                    .catch(() => {
                        this.$message({
                            type:'info',
                            message:'已取消离开秘境'
                        })
                    })

            },
            collapse(){
                this.$emit('doCollapse')
            }

        }

    }
</script>

<style scoped>

.el-button--small{
  padding:9px 10px;
}
@font-face {
  font-family:'aixinziti';
  src: url("../assets/fonts/爱心字体.ttf");
}
.text2{
  display: flex;
  justify-content: center;
  flex: 1;
}
svg {
  margin-top: 4px;
display: flex;
  width: 360px;
  height: 50px;
}

svg text {

  font-size: 30px;
  fill: rgba(148, 74, 0, 0); /* 初始填充颜色为透明 */
  stroke-width: 1px;
  stroke:black;
  stroke-dasharray: 300;
  stroke-dashoffset: 300;
  animation-name: txtain-loop;
  animation-duration: 18s;
  animation-iteration-count: infinite;
  animation-timing-function: linear; /* 添加速度曲线 */
}

@keyframes txtain-loop {
  0% {
    stroke-dashoffset: 300;
    fill: rgba(148, 74, 0, 0); /* 初始填充颜色为透明 */
  }
  44.44% { /* 8s / 18s ≈ 44.44% */
    stroke-dashoffset: 0;
    fill: rgba(148, 74, 0, 0); /* 描边过程中保持透明 */
  }
  44.44% { /* 稍微超过44.44%以确保切换 */
    stroke-dashoffset: 0;
    fill: rgba(148, 74, 0, 0); /* 描边完成后填充颜色变为黑色 */
  }
  50.45% { /* 稍微超过44.44%以确保切换 */
    stroke-dashoffset: 0;
    fill: black; /* 描边完成后填充颜色变为黑色 */
  }
  100% {
    stroke-dashoffset: 0; /* 保持描边完成状态 */
    fill: black; /* 保持填充颜色为黑色 */
    animation-timing-function: steps(1, end); /* 确保在这段时间内不发生变化 */
  }
}
</style>

<style>
/* ===== 离开秘境确认弹窗：20px 圆角 + 粉色美化 =====
   $confirm 的消息框会挂载到 body 上，scoped 样式够不到，必须用全局样式 */
.leave-dialog {
  border-radius: 20px;
  overflow: hidden;
}
.leave-dialog .el-message-box__header {
  background: linear-gradient(160deg, #fff2f8, #ffe6f0);
  padding: 14px 16px 12px;
}
.leave-dialog .el-message-box__title {
  color: #c2457c;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 1px;
}
.leave-dialog .el-message-box__headerbtn {
  top: 13px;
  right: 12px;
}
.leave-dialog .el-message-box__headerbtn:hover .el-message-box__close {
  color: #e0539c;
}
.leave-dialog .el-message-box__content {
  background: #fffafd;
  padding: 22px 24px 10px;
}
.leave-dialog .el-message-box__status.el-icon-warning {
  color: #e0539c; /* 粉色警示图标 */
  font-size: 26px;
}
.leave-dialog .el-message-box__message p {
  color: #5a4450;
  font-size: 15px;
  line-height: 1.7;
}
.leave-dialog .el-message-box__btns {
  background: #fffafd;
  padding: 20px 10px 20px 10px;
  text-align: center;
}
.leave-dialog .el-message-box__btns .el-button {
  border-radius: 12px;
  min-width: 92px;
}
.leave-dialog .el-button--primary {
  background: linear-gradient(135deg, #ff9ec3, #f0619c);
  border-color: transparent;
}
.leave-dialog .el-button--primary:hover,
.leave-dialog .el-button--primary:focus {
  background: linear-gradient(135deg, #ff8fba, #e7548d);
  border-color: transparent;
}
.leave-dialog .el-button--default {
  border: 1px solid #f3a9c6;
  color: #c9578b;
  background: #ffffff;
}
.leave-dialog .el-button--default:hover,
.leave-dialog .el-button--default:focus {
  border-color: #e0539c;
  color: #e0539c;
  background: #fff6fa;
}
</style>
